<script lang="ts">
import { link } from 'svelte-spa-router'
import { _ } from '../i18n.svelte'
</script>
<template lang="pug">
header
    h1.header__title__wrapper
        a.__hover-opacity__0-5(href="/" use:link)
            img(alt="[***] ロゴ" src="/icon.svg")
</template>
<style lang="scss">
header {
    width: calc(100vw - 15px);
    padding: 1% 0;
    .header__title__wrapper {
        width: 2rem;
        margin: 0 auto;
    }
}
</style>
